<template>
  <a-select v-model="selected" placeholder="标题/ID" :filter-option="false" allow-clear show-search @search="onSearch" @select="onSelect">
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="(item, index) in dataSource" :key="index" :value="item.id">{{ `PR-${item.id} ${item.title}` }} </a-select-option>
  </a-select>
</template>

<script>
import { debounce } from 'lodash';
import { storySearch } from '@/api/project/story';
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    onlyParant: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: undefined
    },
    projectId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      dataSource: [],
      filterForm: {
        value: null,
        status: [1, 2, 3, 4, 5],
        page_size: 20,
        page_number: 1
      }
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      }
    }
  },
  created() {
    if (this.method !== 'focus') {
      this.filterData();
    }
  },
  methods: {
    /**
     * 获取需求列表
     */
    filterData() {
      this.loading = true;
      this.requirementData = [];
      this.expendedKeys = [];
      if (this.onlyParant) {
        this.filterForm.parent_id = 0;
      }
      storySearch({ ...this.filterForm })
        .then(res => {
          this.dataSource = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onSelect(value) {
      const res = this.dataSource.find(item => item.id === value);

      if (res) {
        this.$emit('update:projectId', res.project_id);
      }
    },

    onSearch: debounce(function (value) {
      this.filterForm.value = value;
      this.filterData();
    }, 500)
  }
};
</script>
